import 'whatwg-fetch';
import Fetch from '../components/util/Fetch';

const logEvent = (eventType) => {
  const logType = `/log_event/${eventType}`;
  fetch(logType, {
    method: 'POST',
    mode: 'no-cors',
    credentials: 'include',
  })
    .catch((err) => console.error.bind(this, `${logType} fetch error`, err));
};

const logCrmEvent = (eventType, eventDetails = {}) => {
  const logType = `/log_crm_event/${eventType}`;
  const params = { details: eventDetails };
  Fetch.post({ url: logType, payload: params, keepalive: true });
};

export { logEvent, logCrmEvent };
